import styled from 'styled-components';
import { Container, Stack } from '@workramp/ui';

export const WrapperHeaderDashboard = styled.div`
  padding-top: ${({ theme }) => theme.spacing(2)}px;
  padding-bottom: ${({ theme }) => theme.spacing(6)}px;
  padding-left: ${({ theme }) => theme.spacing(8)}px;
  padding-right: ${({ theme }) => theme.spacing(8)}px;
`;

export const WrapperStatsPanelDashboard = styled.div`
  padding-left: ${({ theme }) => theme.spacing(8)}px;
  padding-right: ${({ theme }) => theme.spacing(8)}px;
`;

export const WrapperExportButton = styled.div`
  padding-left: ${({ theme }) => theme.spacing(8)}px;
  padding-right: ${({ theme }) => theme.spacing(8)}px;
`;

export const StyledContainer = styled(Container)`
  margin-left: ${({ theme }) => theme.spacing(0)}px;
  margin-right: ${({ theme }) => theme.spacing(0)}px;
  padding-left: ${({ theme }) => theme.spacing(0)}px;
  padding-right: ${({ theme }) => theme.spacing(0)}px;
`;

export const AssetDashboardStack = styled(Stack)`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 64px);
  padding-top: ${({ theme }) => `${theme.spacing(6)}px`};
  overflow-y: scroll;
  flex: 1 1 auto;
`;
